var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriverLicence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 8H2V32H38V8ZM14.1665 20.6917C14.1665 20.7685 14.164 20.8455 14.159 20.9227C14.9745 20.4867 15.9993 20.2303 15.9993 20.2303C15.9993 20.2303 15.4646 20.8457 15.0827 21.9996C14.7515 23.0002 13.2716 23.7115 12.8841 23.8829C12.5889 24.2355 12.2618 24.5413 11.9242 24.7782C11.9524 25.2319 11.991 25.7321 12.0416 26.156C12.6187 26.3958 13.2232 26.5891 13.7672 26.7395C14.8636 27.0424 15.7632 27.8875 16 29.0001H5C5.23676 27.8875 6.13635 27.0424 7.23281 26.7394C7.77433 26.5897 8.3759 26.3974 8.95056 26.159C9.00167 25.7333 9.04145 25.2301 9.07098 24.7743C8.73556 24.5381 8.41061 24.2341 8.11711 23.8839C7.7331 23.7142 6.24816 23.0021 5.91634 21.9996C5.5344 20.8457 4.99967 20.2303 4.99967 20.2303C4.99967 20.2303 6.02508 20.4869 6.84064 20.923C6.83569 20.8457 6.83316 20.7686 6.83316 20.6917C6.83316 18.4931 8.66724 16.9993 10.5012 17C12.3352 17.0007 14.1665 18.4931 14.1665 20.6917ZM19 18H31V20H19V18ZM36 22H19V24H36V22ZM19 26H34V28H19V26ZM36 11H4V13H36V11Z",
    fill: "#9A9CAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverLicence);
export default __webpack_public_path__ + "static/media/driver-licence.7aca8157.svg";
export { ForwardRef as ReactComponent };